import { useDeveloperModeEnabled } from '@chipinside/devmode'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { TopAlert } from '#/components/Alerts/Top'
import { ResolvedPage } from '#/store/services/Pages/types'
import { usePages } from '#/store/services/Pages/usePages'
import { copyToClipboard } from '#/utils/copyToClipboard'
import { PortalTop } from '#/utils/portal'

export const PlaywrightAlert = () => {
  const devMode = useDeveloperModeEnabled()

  if (!devMode) return null

  return <PlaywrightAlertContent />
}

const PlaywrightAlertContent = () => {
  const { pathname } = useLocation()
  const pages = usePages()

  const [page, setPage] = useState<ResolvedPage>()

  useEffect(() => {
    // O Playwright precisa ver todas as páginas cadastradas, independente de permissão
    const currentPage = pages.getCurrent({ bypassPermissions: true, path: pathname })

    setPage(currentPage)
  }, [pathname, pages])

  // Se a página já estiver mapeada, não exibe o alerta
  if (page) return null

  // Função auxiliar para obter o contexto
  const getContext = (pathname: string) => (pathname.startsWith('/farm') ? 'farm' : 'system')

  // Função auxiliar para obter a URL formatada
  const getUrl = (pathname: string) => {
    return pathname.replace(/^\/farm\/[^/]+/, '/farm/{farm}')
  }

  const getID = (pathname: string) => {
    const context = getContext(pathname)
    const path = pathname?.replace(/^\/farm\/[^/]+\//, '')?.replaceAll('/', '-')

    return `${context}-${path}`.replace('--', '-')
  }

  // Função auxiliar para montar o objeto de cópia
  const buildCopyObject = () => {
    const context = getContext(pathname)
    const url = getUrl(pathname)
    const id = getID(pathname)

    return {
      [id]: {
        context,
        crumbs: [],
        description: '',
        enabled: () => true,
        title: '',
        track: '',
        type: '',
        url,
      },
    }
  }

  const handleCopy = () => {
    const text = JSON.stringify(buildCopyObject())
    copyToClipboard(text + ', \n')
  }

  return (
    <PortalTop>
      <TopAlert
        severity="dev"
        variant="filled"
        title={'Página não cadastrada no Playwright'}
        content={[window?.location?.pathname]}
        onClick={handleCopy}
      />
    </PortalTop>
  )
}
